<div class="login-container">

  <div class="right-side" [ngStyle]="{ 'background-image': 'url(' + randomImage + ')' }">


    <mat-card class="login-card animate__animated animate__fadeInRight" style="position: relative;">
      <mat-card-content style="width: -webkit-fill-available;">

        <div class="message animate__animated animate__fadeInRight">
          bienvenido a Simpli
        </div>

        <div style="text-align: center;">
          <img src="../../assets/img/simplilogo.svg" style="height: 100px;margin-top: 20px;margin-bottom: 20px;"/>
        </div>

        <p *ngIf="step === 'email'" style="text-align:center;color:var(--simpli-secondary);font-size:14px;margin:0 0 16px;">
          Te enviaremos un código de acceso a tu correo
        </p>

        <form *ngIf="step === 'email'" [formGroup]="valForm" (submit)="requestCode($event)" class="form-login animate__animated animate__fadeIn" >

          <mat-form-field appearance="fill">
              <mat-label>Correo Electrónico</mat-label>
              <input formControlName="email" matInput type="email" placeholder="tu@simplilatam.com">
              <mat-icon color="primary" matSuffix style="color: var(--simpli-secondary);">email</mat-icon>
              <mat-hint>Ingresa tu correo electrónico</mat-hint>
              <mat-error *ngIf="valForm.controls['email'].hasError('required') && (valForm.controls['email'].dirty || valForm.controls['email'].touched)">
                  Email es <strong>requerido</strong>
              </mat-error>

              <mat-error *ngIf="valForm.controls['email'].hasError('email') && (valForm.controls['email'].dirty || valForm.controls['email'].touched)">
                  Debe ser un correo electrónico valido
              </mat-error>

              <mat-error *ngIf="valForm.controls['email'].hasError('orgNotAllowed')">
                  {{ valForm.controls['email'].getError('orgNotAllowed') }}
              </mat-error>
          </mat-form-field>

          <div class="btn-container">
              <button class="primary-button-log" style="margin-right: 0px;" [disabled]="disabled" mat-flat-button type="submit" color="primary">
                <mat-label *ngIf="disabled == false">Enviar código</mat-label>
                <mat-spinner *ngIf="disabled == true" diameter="18"></mat-spinner>
              </button>
          </div>

        </form>

        <form *ngIf="step === 'code'" [formGroup]="codeForm" (submit)="verifyCode($event)" class="form-login animate__animated animate__fadeIn" >

          <p style="text-align:center;">Enviamos un código de acceso a<br><strong>{{ valForm.value.email }}</strong></p>

          <mat-form-field appearance="fill">
              <mat-label>Código de acceso</mat-label>
              <input formControlName="code" matInput type="text" inputmode="numeric" maxlength="6" placeholder="000000" style="letter-spacing: 4px;">
              <mat-hint>Ingresa el código de 6 dígitos que enviamos a tu correo</mat-hint>
              <mat-error *ngIf="codeForm.controls['code'].hasError('required') && codeForm.controls['code'].touched">
                  El código es <strong>requerido</strong>
              </mat-error>
              <mat-error *ngIf="codeForm.controls['code'].hasError('pattern') && codeForm.controls['code'].touched">
                  Debe tener 6 dígitos
              </mat-error>
              <mat-error *ngIf="codeForm.controls['code'].hasError('invalid')">
                  {{ codeForm.controls['code'].getError('invalid') }}
              </mat-error>
          </mat-form-field>

          <div class="btn-container">
              <button class="primary-button-log" style="margin-right: 0px;" [disabled]="disabled" mat-flat-button type="submit" color="primary">
                <mat-label *ngIf="disabled == false">Iniciar Sesión</mat-label>
                <mat-spinner *ngIf="disabled == true" diameter="18"></mat-spinner>
              </button>
          </div>

          <div class="center-div">
              <a mat-button type="button" [disabled]="resendCooldown > 0 || disabled" (click)="resendCode()" style="color:var(--simpli-secondary);">
                {{ resendCooldown > 0 ? 'Reenviar código (' + resendCooldown + 's)' : 'Reenviar código' }}
              </a>
          </div>

        </form>

        <div class="center-div" *ngIf="step === 'code'">
            <a mat-button type="button" (click)="backToEmail()" style="color:var(--simpli-secondary);">Usar otro correo</a>
        </div>

      </mat-card-content>
    </mat-card>
  </div>
</div>
